<template>
  <div class="how-it-works">
    <div class="how-it-works__items">
      <div 
        v-for="(item, i) in items"
        :key="i"
        class="how-it-works__item"
      >
        <div class="item__number">{{ i + 1 }}</div>
        <div class="item__text" v-html="item.text"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HowItWorks',
  designVersion: '1.0.0',
  props: {
    /**
     * Массив пунктов с форматированными текстами
     */
    items: {
      type: Array,
    },

  },
};
</script>

<style lang="scss" scoped>
  @import "./HowItWorks";
</style>
